<template>
    <div class="m-right-side" :class="{ isHome: isHome }">
        <SideMsg></SideMsg>
        <!-- 贡献排行榜 -->
        <Rank></Rank>

        <div class="m-group">
            <h2 class="m-title">
                <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M256 256h85.333v21.333C341.333 300.897 360.436 320 384 320s42.667-19.103 42.667-42.667V256H512V42.667C512 19.103 492.897 0 469.333 0H256z" fill="#dd636e"/><path d="M469.333 0H384v320c23.564 0 42.667-19.103 42.667-42.667V256H512V42.667C512 19.103 492.897 0 469.333 0z" fill="#d82e3d"/><path d="M256 256v-85.333h21.333C300.897 170.667 320 151.564 320 128s-19.103-42.667-42.667-42.667H256V0H42.667C19.103 0 0 19.103 0 42.667V256z" fill="#ffe646"/><path d="M277.333 85.333H256V0H128v256h128v-85.333h21.333C300.898 170.667 320 151.564 320 128s-19.102-42.667-42.667-42.667z" fill="#ffc81e"/><path d="M256 256h-85.333v-21.333C170.667 211.102 151.564 192 128 192s-42.667 19.102-42.667 42.667V256H0v213.333C0 492.897 19.103 512 42.667 512H256z" fill="#d49eee"/><path d="M256 512V256h-85.333v-21.333C170.667 211.103 151.564 192 128 192v320z" fill="#b77ede"/><path d="M256 256v85.333h-21.333C211.102 341.333 192 360.436 192 384s19.102 42.667 42.667 42.667H256V512h213.333C492.897 512 512 492.897 512 469.333V256z" fill="#badc1e"/><path d="M384 512h85.333C492.897 512 512 492.897 512 469.333V256H384z" fill="#73be14"/><path d="M341.333 249v28.333C341.333 300.897 360.436 320 384 320s42.667-19.103 42.667-42.667V249z" fill="#dd636e"/><path d="M384 246v74c23.564 0 42.667-19.103 42.667-42.667V246z" fill="#d82e3d"/></svg>
                <span class="u-text">各区服成就群</span>
                <a class="u-show-message" target="_blank" href="https://www.jx3box.com/tool/13659/">申请展示 »</a>
            </h2>
            <div class="m-group-content">
                <!-- <el-tree
                    class="m-group-tree"
                    :default-expand-all="false"
                    :data="groups"
                    node-key="uuid"
                    @node-click="clickNode"
                /> -->
                <el-collapse v-model="activeName" accordion>
                    <el-collapse-item
                        :title="group.label"
                        :name="group.label"
                        v-for="group in groups"
                        :key="group.uuid"
                    >
                        <div class="u-zones" v-for="zone in group.children" :key="zone.uuid">
                            <el-tag class="u-zone" size="mini">{{ zone.label }}</el-tag>
                            <span
                                size="mini"
                                class="u-qq"
                                v-for="qq in zone.children"
                                :key="qq.uuid"
                                @click="copy(qq.label)"
                                >{{ qq.label }}</span
                            >
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    </div>
</template>

<script>
import { getMenuGroup } from "@/service/group";
import { __ossRoot, __ossMirror } from "@jx3box/jx3box-common/data/jx3box.json";
import SideMsg from "@/components/common/side-msg.vue";
import Rank from "@/components/common/rank.vue";
import { v4 as uuid } from "uuid";

export default {
    name: "Extend",
    components: {
        SideMsg,
        Rank,
    },
    props: {
        type: {
            type: String,
            default: "achievement",
        },
    },
    data() {
        return {
            ranks: [],
            groups: [],
            isHome: true,

            activeName: "",
            qq: "614370825",
        };
    },
    computed: {
        client() {
            return this.$store.state.client;
        },
    },
    methods: {
        clickNode(data) {
            if (!data.children) {
                const val = data.label;
                this.copy(val);
            }
        },
        copy(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$notify({
                    title: "复制成功",
                    message: text,
                    type: "success",
                });
            });
        },
        copy_success() {
            this.$notify({ title: "复制成功", type: "success" });
        },
        copy_error() {
            this.$notify({ title: "浏览器不支持", type: "error" });
        },
        checkIsHome: function () {
            this.isHome = this.$route.name == "home" || !this.$route.name;
        },
        onQQClick() {
            navigator.clipboard.writeText(this.qq).then(() => {
                this.$notify({
                    title: "复制成功",
                    message: "内容：" + this.qq,
                    type: "success",
                });
            });
        },
        loadGroups() {
            getMenuGroup("wiki_cj_group").then((res) => {
                const groups = res.data?.data?.menus || [];
                const newGroups = groups.map((item) => {
                    return {
                        zone: item.label.split("/")[0],
                        server: item.label.split("/")?.[1] || "",
                        children: item.link.split("/"),
                        priority: item.priority,
                    };
                });
                this.groups = this.convertToTree(newGroups);
            });
        },
        convertToTree(data) {
            const tree = {};

            data.forEach((item) => {
                const zone = item.zone;

                if (!tree[zone]) {
                    tree[zone] = {
                        label: zone,
                        children: [],
                        uuid: uuid(),
                    };
                }

                const serverNode = {
                    label: item.server,
                    children: item.children.map((val) => {
                        return {
                            label: val,
                            uuid: uuid(),
                        };
                    }),
                    priority: item.priority,
                    uuid: uuid(),
                };

                tree[zone].children.push(serverNode);
            });

            return Object.values(tree);
        },
    },
    mounted() {
        // 获取成就群
        this.loadGroups();
        this.checkIsHome();
    },
    watch: {
        "$route.name": function () {
            this.checkIsHome();
        },
    },
};
</script>

<style lang="less">
@import "~@/assets/css/cj/right-side.less";
.m-group-tree {
    .is-leaf + .el-tree-node__label:before {
        content: "»";
        color: #3d454d;
        margin-right: 5px;
    }
}
</style>
